import { useLayoutEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { useIsMounted } from '@hooks/useIsMounted';
import { useScrollController } from '@context/ScrollControllerProvider/useScrollController';
import ScrollMagic from 'scrollmagic';

export const useOurValuesController = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const containerEl = containerRef.current;
  const assetsRef = useRef<HTMLDivElement>(null);
  const assetsEl = assetsRef.current;

  const scrollController = useScrollController();
  const isMounted = useIsMounted();

  useLayoutEffect(() => {
    let scene: InstanceType<typeof ScrollMagic.Scene> | undefined;
    let timeline: ReturnType<typeof gsap.timeline>;
    if (scrollController && isMounted && containerEl) {
      timeline = gsap.timeline({ paused: true });
      timeline.to(assetsEl, { bottom: 0 }, 0);
      scene = new ScrollMagic.Scene({
        triggerElement: containerEl,
        triggerHook: 'onLeave',
        duration: '100%',
        offset: 0,
      })
        .addTo(scrollController)
        .on('progress', (event: ScrollMagic.SceneProgressEvent) => {
          timeline?.progress(event.progress);
        });
    }
    const clearScene = () => {
      if (timeline) {
        timeline.progress(0);
        timeline.kill();
      }
      if (scene) {
        scene.destroy(true);
      }
    };
    return clearScene;
  }, [isMounted, scrollController, assetsEl, containerEl]);
  return {
    containerRef,
    assetsRef,
  };
};
